import React, { useState } from "react";
import { motion } from "framer-motion";

const buttonVariants = {
  hover: {
    boxShadow: "0px 7px 29px 0px rgba(100, 100, 111, 0.2)",
    scale: 1.1,
    backgroundColor: "#222",
    color: "#fff",
    borderColor: "#222",
    transition: {
      duration: 0.3,
    },
  },
};

const Contact = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [number, setNumber] = useState("");
  const [description, setDescription] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const [submit, setSubmit] = useState("");

  const submitHandler = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    let myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    if (!name || !email) {
      alert("please tell us your name and email");
      return;
    }
    let requestOptions = {
      method: "post",
      headers: myHeaders,
      redirect: "follow",
      body: JSON.stringify([[name, email, number, description]]),
    };
    try {
      const data = await fetch(
        "https://v1.nocodeapi.com/skidev/google_sheets/AXBTdTbUWlRIDoCE?tabId=2022",
        requestOptions
      );
      const res = await data.text();
      setSubmitting(false);
      setSubmitted(true);
    } catch (error) {
      console.log(error);
    }
  };

  if (submitted) {
    return (
      <div className="min-h-screen mt-16 flex justify-center items-center">
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <img
            src="https://adniti.in/wp-content/uploads/2020/05/giphy7.gif"
            alt="loader"
            width="500px"
          />
          <h1>Form Submitted Sucessfully. Thank You!</h1>
        </div>
      </div>
    );
  }
  return (
    <div
      className="min-h-screen mt-16 flex justify-center items-center"
      id="contact"
    >
      {submitting ? (
        <>
          <img
            src="https://i.pinimg.com/originals/13/fa/be/13fabe368d08211706da14d461727b50.gif"
            alt="submitting form"
            width="500px"
          />
        </>
      ) : (
        <>
          <div className="max-w-6xl w-full p-3">
            <div className="flex p-3 flex-col-reverse md:flex-row">
              <div className="w-full">
                <h2 className="block md:text-8xl text-6xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-[#DD2476] via-[#FB680B] to-[#FF522C]">
                  Let's Jam
                </h2>

                <form className="mt-4" onSubmit={(e) => submitHandler(e)}>
                  <div className="mb-5">
                    <input
                      type="text"
                      className="p-2 border-0 outline-none border-b-2 w-full md:w-1/2 border-gray-600"
                      placeholder="Name"
                      onChange={(e) => setName(e.target.value)}
                    />
                  </div>

                  <div className="mb-5">
                    <input
                      type="text"
                      className="p-2 border-0 outline-none border-b-2 w-full md:w-1/2 border-gray-600"
                      placeholder="E-Mail"
                      onChange={(e) => setEmail(e.target.value)}
                    />
                  </div>

                  <div className="mb-5">
                    <input
                      type="text"
                      className="p-2 border-0 outline-none border-b-2 w-full md:w-1/2 border-gray-600"
                      placeholder="Phone"
                      onChange={(e) => setNumber(e.target.value)}
                    />
                  </div>

                  <div className="mb-5">
                    <input
                      type="text"
                      className="p-2 border-0 outline-none border-b-2 w-full md:w-1/2 border-gray-600"
                      placeholder="Description"
                      onChange={(e) => setDescription(e.target.value)}
                    />
                  </div>
                  <div className="md:w-1/2">
                    <motion.button
                      variants={buttonVariants}
                      whileHover="hover"
                      className="border-2 mt-11 block mx-auto md:mx-0 py-4 px-7 border-gray-700"
                    >
                      Let's dooo this!
                    </motion.button>
                  </div>
                </form>
              </div>

              <div>
                <img
                  src="./assets/images/Contact.jpg"
                  className="w-full hidden md:block"
                  alt="contact"
                />
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default Contact;
